import Main from "../../../assets/images/projects/blibli-histeria/main.png";
import Alternative from "../../../assets/images/projects/blibli-histeria/alternative.png";
import EntryPoint from "../../../assets/images/projects/blibli-histeria/entry-point.png";
import Last from "../../../assets/images/projects/blibli-histeria/last.png";

import { ProjectDetailProps } from "../props";

export default {
  title: "Blibli Histeria",
  timeline: "Q4 - 2019",
  context:
    "A Gamification promo visual indicator for the customer to indicate the current position/achievement based on customer’s shopping behavior data. On Eleven eleven (November 11th 2019), Blibli offer 9.000.000 total cashback in 16 categories for 500.000 per each.",
  team: [
    "Freddy Albert Sanjaya - UX designer",
    "Okky Soedargo - UI designer ",
    "Steven Nugraha - UX researcher",
    "Clara Parwanty - UX copywriter",
  ],
  thumbnail: Main,
  contents: [
    {
      left: {
        title: "Process",
        content: (
          <div>
            <p>
              Start with exploration on the objectives and the requirement
              dashboard as like gamification on the customer. I initiated to
              deep-through with the researcher so we can get more context on the
              customer perspectives for fulfiling what we can improve into the
              promotion.
            </p>
            <p>
              From the research that we gathered in gamifaction based on the
              people’s interest, we found that mostly about 66% of our customers
              are in achiever type*. They are interest to achieve to get
              something. On this case make a variation of gamification such as
              progress bar, leveling, mission, and milestone came to the
              alternatives decision.
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: (
          <div>
            Then, after tweak some variation on the design, we come up with this
            insights:
            <ul>
              <li>
                User must know where is their state and their maximum they can
                get; tracking the progress will help them to know where are they
                now
              </li>
              <li>
                On the leveling case, a distinction between each level and what
                is their reward if they achieved certain of levels must be a
                consideration if we come up with that type of bar
              </li>
              <li>
                Straightforward, more simpler more better. A pretty
                straightforward indicator of bar and show the progress on what
                they achieved.
              </li>
              <li>
                An access point on each category will help user seamlessly.
              </li>
            </ul>
          </div>
        ),
      },
      bottomImage: Alternative,
    },
    {
      left: {
        title: "",
        content: (
          <div>
            <p>
              For the overview, the rounded score showed the total cashback,
              following with the category bar per each. The entry point for the
              Scorecard promotion would be on the homepage. The Dashboard page
              showed the cashback that customer would get on each category with
              16 categories in total with 500.000 IDR cashback offer and would
              get potentially 9.000.000 IDR in total.
            </p>
            <p>
              There was 3 days limit for user to get the promotion and terms and
              conditions to get the cashbacks. That’s why onboarding would help
              them to address on how they would get the cashback easily.
            </p>
          </div>
        ),
      },
      bottomImage: EntryPoint,
    },
    {
      left: {
        title: "Final Experience",
        content: (
          <div>
            <p>
              Together with the UI Designer and the copywriter, we tweak more
              for engaging design and copywritings. The result is quite
              interesing and meet the expectations. You can see the final design
              on the below.
            </p>
          </div>
        ),
      },
      right: {
        title: "Impact",
        content: "Cashback dashboard 11.11 achieved GMV target by 200%!",
      },
      bottomImage: Last,
    },
  ],
} as ProjectDetailProps;
